module.exports = "img/flags/DZ.e03620b.png";